import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Company } from '../../models/company.model';

type CompanyPayload = Omit<
  Company,
  'id' | 'linked_quote_count' | 'created_at' | 'updated_at'
>;

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  private http = inject(HttpClient);
  private apiUrl = '/quotes-api/companies/';

  private companiesSubject = new BehaviorSubject<Company[]>([]);
  companies$ = this.companiesSubject.asObservable();

  async loadCompanies(): Promise<void> {
    const companies = await firstValueFrom(
      this.http.get<Company[]>(this.apiUrl),
    );
    this.companiesSubject.next(companies);
  }

  async createCompany(payload: CompanyPayload): Promise<Company> {
    const company = await firstValueFrom(
      this.http.post<Company>(this.apiUrl, payload),
    );
    await this.loadCompanies();
    return company;
  }

  async updateCompany(id: number, payload: CompanyPayload): Promise<Company> {
    const company = await firstValueFrom(
      this.http.patch<Company>(`${this.apiUrl}${id}/`, payload),
    );
    await this.loadCompanies();
    return company;
  }

  async deleteCompany(id: number): Promise<void> {
    await firstValueFrom(this.http.delete(`${this.apiUrl}${id}/`));
    await this.loadCompanies();
  }
}
